import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const TooltipControl = (function($) {
		
	var timer;
	
	var _show = function(link, content, callback) {
		
		var linkPosition = $(link).offset(),
			popUpPositionLeft = linkPosition.left + $(link).width() + 5,
			popUpPositionTop = linkPosition.top + Math.floor( $(link).height() / 2 );
		
		clearTimeout(timer);
		
		var messageBox = $("#"+LS2PAC_CONSTANTS.Ids.tooltip);
		messageBox.find("."+LS2PAC_CONSTANTS.CssClasses.content).html(content);
		messageBox.css({
			top: popUpPositionTop + "px",
			left: popUpPositionLeft + "px"
		});
		
		timer = setTimeout(function(){
			messageBox.fadeIn("fast", function(){
				if(callback){
					callback(content);
				}
			});
			// setTimeout(_hide, 2000);  //This is to fix tooltip not going away
		}, 400); //TODO: find out if this is the most efficient and desired functionality
	};
	
	var _hide = function(callback){
		var messageBox = $("#"+LS2PAC_CONSTANTS.Ids.tooltip);
		
		clearTimeout(timer);
		
		timer = setTimeout(function(){
			messageBox.fadeOut("fast", function(){
				if(callback){
					callback();
				}
			})
		}, 400);
	};
	
	return {
		show: function(link, callback) {
			var content = link.rel;
			_show(link, content, callback);
			
		},
		hide: function(callback){
			_hide(callback);
		}
	}
})(jQuery);